// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingPage_loader-container__6MZVt {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: #fff;
  z-index: 1;
}

.LoadingPage_spinner__uLsI3 {
  width: 64px;
  height: 64px;
  border: 8px solid;
  border-color: #1f1f1f transparent #fa7a18 transparent;
  border-radius: 50%;
  animation: LoadingPage_spin-anim__vocPg 1.2s linear infinite;
}

@keyframes LoadingPage_spin-anim__vocPg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Home/LoadingPage/LoadingPage.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qDAAA;EACA,kBAAA;EACA,4DAAA;AAAJ;;AAGA;EACI;IACI,uBAAA;EAAN;EAEE;IACI,yBAAA;EAAN;AACF","sourcesContent":["@use 'styles/colors';\n.loader-container {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    background: #fff;\n    z-index: 1;\n}\n\n.spinner {\n    width: 64px;\n    height: 64px;\n    border: 8px solid;\n    border-color: colors.$secondary transparent #fa7a18 transparent;\n    border-radius: 50%;\n    animation: spin-anim 1.2s linear infinite;\n}\n\n@keyframes spin-anim {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader-container": `LoadingPage_loader-container__6MZVt`,
	"spinner": `LoadingPage_spinner__uLsI3`,
	"spin-anim": `LoadingPage_spin-anim__vocPg`
};
export default ___CSS_LOADER_EXPORT___;
